var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5693 5.92053C19.4836 5.52882 20.5184 5.52873 21.4326 5.92053L30.5098 9.81116C31.9985 10.4492 32.8863 11.995 32.6855 13.6022L31.9414 19.5524C31.4521 23.4669 29.4935 27.0493 26.4629 29.5748L22.3271 33.0211C20.9792 34.1443 19.0217 34.1444 17.6738 33.0211L13.5381 29.5748C10.5075 27.0493 8.54888 23.4669 8.05957 19.5524L7.31641 13.6022C7.11561 11.995 8.00247 10.4492 9.49121 9.81116L18.5693 5.92053Z",
    stroke: "url(#paint0_linear_623_3435)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 20L18.9709 23.9716C19.503 24.5036 20.3888 24.4159 20.8061 23.7898L26.666 15",
    stroke: "url(#paint1_linear_623_3435)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3435",
    x1: 8.33398,
    y1: 20,
    x2: 31.6673,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3435",
    x1: 20.8327,
    y1: 15,
    x2: 20.8327,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPld);
export default __webpack_public_path__ + "static/media/PLD.82a3526d7f27ee3fa219f221d0b587de.svg";
export { ForwardRef as ReactComponent };